export namespace COLOR {
    export const primaryStartColor = '#2874A6';
    export const primaryEndColor = '#D6EAF8';
    export const secondaryStartColor = '#1D8348';
    export const secondaryEndColor = '#D5F5E3';
}
